import { Box, Stack, Tooltip } from '@mui/material';
import { Currency } from '@synergy/models';
import { FormattedNumber } from 'react-intl';
import { PoolRow, PoolTypography } from '@synergy/components-next';
import { ReactElement, ReactNode } from 'react';

import { PoolProgressBar } from './progressbar';

export interface OrderLimitProps {
    limit: number;
    currentSum: number;
    currency?: Currency;
    title: ReactNode;
    tooltipRender: () => ReactElement;
}

export const OrderLimitBase = (props: OrderLimitProps): ReactElement => {
    const { limit, currentSum, currency, title } = props;

    return (
        <Box sx={{ width: '280px' }}>
            <Tooltip title={props.tooltipRender()} placement="bottom">
                <Stack flexDirection="row" justifyContent="space-between">
                    <Box alignSelf="flex-start" typography="body1">
                        <strong>{title}</strong>
                    </Box>
                    <PoolRow typography="body1" alignItems="center">
                        <strong>
                            <FormattedNumber
                                value={currentSum < limit ? limit - currentSum : 0}
                                style="currency"
                                currency={currency}
                                maximumFractionDigits={0}
                            />
                        </strong>
                        <PoolTypography typography="caption" translationId="app.orderLimit.available" />
                    </PoolRow>
                </Stack>
            </Tooltip>

            <PoolProgressBar currentSum={currentSum} limit={limit} sx={{ width: '280px', mt: 0.5 }} />
        </Box>
    );
};
